import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function PropertyManage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">매물장 관리는 이제 그만!<br />고객정보, 상담내역, 일정 등이 자동으로 통합 관리되요</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className="guide_view"><Image className="img_guide" src="/image/desktop/popup/property01_01.png" alt={"\uB514\uC9C0\uD138 \uB9E4\uBB3C\uC7A5 \uD654\uBA74"} width={100} height={100} /></div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}